"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addGoogleServiceTagScript = exports.addGoogleAdsScript = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
/* eslint-disable no-unused-expressions */

/* eslint-disable dot-notation */
// eslint-disable-next-line no-unused-vars


var addGoogleServiceTagScript = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
    var script;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            script = document.createElement('script');
            script.src = 'https://www.googletagservices.com/tag/js/gpt.js';
            script.async = true;
            document.body.appendChild(script);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function addGoogleServiceTagScript() {
    return _ref.apply(this, arguments);
  };
}();

exports.addGoogleServiceTagScript = addGoogleServiceTagScript;

var getSizeForWidth = function getSizeForWidth(width) {
  if (width >= 1170) {
    return [1162, 280];
  }

  if (width >= 700 && width < 1170) {
    return [656, 280];
  }

  if (width >= 540 && width < 748) {
    return [540, 90];
  }

  return [300, 250];
};

var addGoogleAdsScript = function addGoogleAdsScript(adsId, slot, specificPageSize) {
  window['googletag'] = window['googletag'] || {
    cmd: []
  };
  window['googletag'].cmd.push(function () {
    var _window, _window2, _window3, _window4, _window5;

    var slotSize = '';

    if (specificPageSize) {
      slotSize = specificPageSize;
    } else {
      var width = window.innerWidth || document.documentElement.clientWidth;
      slotSize = getSizeForWidth(width);
    }

    (_window = window) === null || _window === void 0 || (_window = _window.googletag) === null || _window === void 0 || (_window = _window.defineSlot(slot, slotSize, adsId)) === null || _window === void 0 || _window.addService(window.googletag.pubads());
    (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.googletag) === null || _window2 === void 0 || (_window2 = _window2.pubads()) === null || _window2 === void 0 || _window2.collapseEmptyDivs();
    (_window3 = window) === null || _window3 === void 0 || (_window3 = _window3.googletag) === null || _window3 === void 0 || (_window3 = _window3.pubads()) === null || _window3 === void 0 || _window3.setCentering(true);
    (_window4 = window) === null || _window4 === void 0 || (_window4 = _window4.googletag.pubads()) === null || _window4 === void 0 || _window4.enableSingleRequest();
    (_window5 = window) === null || _window5 === void 0 || (_window5 = _window5.googletag) === null || _window5 === void 0 || _window5.enableServices();
  });
};

exports.addGoogleAdsScript = addGoogleAdsScript;